import apiClient from './client';
import { API_PATHS } from '../utils/constants';

export async function submitTicket(payload) {
  const { data } = await apiClient.post(API_PATHS.tickets.submit, payload);
  return data;
}
